/**
 * @description
 *
 * @sort id
 */
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
    },
    {
        text: 'bodega',
        value: 'wh_warehouse_name',
    },
    {
        text: 'responsable',
        value: 'g_user_name',
    },
    {
        text: 'tipo',
        value: 'wh_stock_adjust_type_name',
        align: 'center',
        component: {
            type: 'chip',
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: 'black',
            },
        },
    },
    {
        text: 'estado',
        value: 'state',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    confirmada: 'success lighten-3',
                    pendiente: 'accent lighten-3',
                },
                small: true,
            },
        },
    },
    {
        text: 'fecha de creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
    },
]
